export * from './PropertyDetailsRentInfo';
